export const GET_PROJECT_ITEMS = 'GET_PROJECT_ITEMS';
export const GET_PROJECT_ITEMS_SUCCESS = 'GET_PROJECT_ITEMS_SUCCESS';
export const GET_PROJECT_ITEMS_ERROR = 'GET_PROJECT_ITEMS_ERROR';
export const RESET_PROJECT_ITEMS = 'RESET_PROJECT_ITEMS';
export const GET_PROJECT_ITEMS_DELAYED = 'GET_PROJECT_ITEMS_DELAYED';

export const SELECT_PROJECT_ITEM = 'SELECT_PROJECT_ITEM';
export const DESELECT_PROJECT_ITEM = 'DESELECT_PROJECT_ITEM';
export const DESELECT_MANY_PROJECT_ITEMS = 'DESELECT_MANY_PROJECT_ITEMS';
export const RESET_PROJECT_ITEMS_ACTIONS = 'RESET_PROJECT_ITEMS_ACTIONS';

export const OPEN_PROJECT_ITEM = 'OPEN_PROJECT_ITEM';
export const CLOSE_PROJECT_ITEM = 'CLOSE_PROJECT_ITEM';

export const SET_PROJECT_ITEMS_FILTERS = 'SET_PROJECT_ITEMS_FILTERS';
